import { render, staticRenderFns } from "./UpdateRewardProgram.vue?vue&type=template&id=c5620458&"
import script from "./UpdateRewardProgram.vue?vue&type=script&lang=js&"
export * from "./UpdateRewardProgram.vue?vue&type=script&lang=js&"
import style0 from "./UpdateRewardProgram.vue?vue&type=style&index=0&id=c5620458&prod&lang=css&"
import style1 from "./UpdateRewardProgram.vue?vue&type=style&index=1&id=c5620458&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports